/**
 * Customer-facing channel health has exactly three states.
 *
 * The service keeps a richer diagnostic vocabulary, but an absent or expired
 * reading is still a failed test from a survey author's point of view: the
 * channel has not proved that it can work. Only an explicit organization
 * disablement is Off.
 */
export function channelHealthResult(control) {
    if (control?.enabled === false) return 'off';
    if (control?.enabled === true
        && control?.runtime_health === 'healthy'
        && !control?.runtime_health_stale) return 'passed';
    return 'failed';
}

export const CHANNEL_HEALTH_LABELS = {
    off: 'Off',
    passed: 'Passed',
    failed: 'Failed',
};

export function channelHealthTone(result) {
    if (result === 'passed') return 'green';
    if (result === 'failed') return 'red';
    return 'neutral';
}
